import { connect } from 'react-redux';
import { selectDisplayBrackets } from '@selectors/bracketView';

import BracketPodium from './BracketPodium';
import { Bracket as BracketType } from '@models/Match';
import { getResult, hasResults } from '@utils/match';

export const mapStateToProps = (state) => {
  const finalBracket = selectDisplayBrackets(state)[BracketType.Final];

  const [final, thirdPlacePlayoff] = finalBracket || [];
  const finalResult = final && hasResults(final) ? getResult(final) : {};
  const thirdResult =
    thirdPlacePlayoff && hasResults(thirdPlacePlayoff)
      ? getResult(thirdPlacePlayoff)
      : {};

  return {
    teams: [
      finalResult?.winner?.team,
      finalResult?.loser?.team,
      thirdResult?.winner?.team,
    ],
  };
};

export default connect(mapStateToProps)(BracketPodium);
